import { render, staticRenderFns } from "./TerminDetails.vue?vue&type=template&id=e211c3ee"
import script from "./TerminDetails.vue?vue&type=script&lang=js"
export * from "./TerminDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports